import { h, defineComponent } from 'vue';
import { LegacyItem } from '@/ui/components/inspectionReport/legacyTypes';
import { useInspectionReport } from '@/ui/components/inspectionReport/useInspectioReport';

interface ConductionInfoTableProps {
  items: Array<LegacyItem>;
}

export const ConductionInfoTable = defineComponent<ConductionInfoTableProps>({
  name: 'ConductionInfoTable',
  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  setup(props) {
    const { getSubItems } = useInspectionReport();

    return function render() {
      if (!props.items.length) {
        return null;
      }

      return h('div', {
        class: 'inspection-report__page-content',
        attrs: { 'data-test': 'conduction-info' },
      }, [getSubItems(props.items)]);
    };
  },
});
